



















































import Vue from "vue";
import { Component } from "vue-property-decorator";
import {
  JinroPlayerDocument,
  JinroRoomDocument,
  UserDocument,
  JinroGameDocument,
} from "@/services/datatypes";
import JinroGamePlayinfo from "@/components/JinroPlayer/JinroGamePlayinfo.vue";
import JinroGame from "@/components/JinroPlayer/JinroGame.vue";
import JinroPlayerGameInfo from "@/components/JinroPlayer/JinroPlayerGameInfo.vue";
import ChatForJinroRoom from "@/components/ChatForSpecificPlayers/ChatForRoom.vue";
import { db } from "@/scripts/firebase";
import { collectionName } from "../services/collection-name";
import { JinroRoomStatus } from "../services/jinro-room-status";
import JinroPlayerSkelton from "@/components/shared/JinroPlayerSkelton.vue";
import PlayerListViewWithStatus from "@/components/shared/PlayerListViewWithStatus.vue";
import SoundControl from "@/components/shared/SoundControl.vue";
import GuestPlayerUrlNotification from "@/components/JinroPlayer/GuestPlayerUrlNotification.vue";

@Component({
  components: {
    JinroGame,
    JinroPlayerGameInfo,
    JinroGamePlayinfo,
    ChatForJinroRoom,
    JinroPlayerSkelton,
    PlayerListViewWithStatus,
    SoundControl,
    GuestPlayerUrlNotification,
  },
})
export default class JinroPlayer extends Vue {
  jinroPlayerDetacher?: firebase.Unsubscribe;
  jinroRoomDetacher?: firebase.Unsubscribe;
  jinroPlayer: JinroPlayerDocument | null = null;
  currentJinroPlayinfoId: string | null = null;
  playerNumber = 0;

  get isGuestPlayerPage(): boolean {
    if (!this.$store.state.jinroPlayer) {
      return false;
    }
    return this.$store.state.jinroPlayer.uid === null;
  }

  get isUser(): boolean {
    if (!this.$store.state.jinroPlayer || !this.$store.state.firebaseUser) {
      return false;
    }

    return (
      this.$store.state.jinroPlayer.uid === this.$store.state.firebaseUser.uid
    );
  }

  get currentDisplayName(): string {
    if (!this.$store.state.user) {
      return "";
    }
    const user = this.$store.state.user as UserDocument;
    return user.displayName;
  }

  get isNameChanged(): boolean {
    return this.currentDisplayName !== this.playerName;
  }
  get playerName(): string {
    if (!this.jinroPlayer) {
      return "";
    }
    return this.jinroPlayer.playerName;
  }

  get isNotDeleted(): boolean {
    if (this.jinroPlayer) {
      return !this.jinroPlayer.isDeleted;
    }

    return true;
  }

  get jinroGameId(): string {
    if (this.jinroPlayer && this.jinroPlayer.currentJinroGameId) {
      return this.jinroPlayer.currentJinroGameId;
    }
    return "";
  }
  get jinroRoomId(): string {
    if (!this.$store.state.jinroRoom) {
      return "";
    }
    return this.$store.state.jinroRoom.id;
  }

  get jinroRoomTitle(): string {
    if (!this.$store.state.jinroRoom) {
      return "";
    }
    return this.$store.state.jinroRoom.title;
  }

  get NotNewGameProcessing(): boolean {
    if (!this.$store.state.jinroRoom) {
      return false;
    }
    const jinroRoom = this.$store.state.jinroRoom as JinroRoomDocument;
    return jinroRoom.jinroRoomStatus !== JinroRoomStatus.ProcessingNewGame;
  }

  async created() {
    this.jinroPlayerDetacher = this.refJinroPlayer.onSnapshot(
      async (snapshot) => {
        if (!snapshot.exists) {
          return;
        }
        this.jinroPlayer = snapshot.data() as JinroPlayerDocument;
        this.jinroPlayer.id = snapshot.id;
        this.$store.commit("setJinroPlayer", this.jinroPlayer);

        const gameId = this.jinroPlayer.currentJinroGameId;
        if (gameId) {
          const gameDoc = await this.refJinroGame(gameId).get();
          const data = gameDoc.data() as JinroGameDocument;
          this.currentJinroPlayinfoId = data.currentJinroPlayinfoId
            ? data.currentJinroPlayinfoId
            : "";
        }

        const jinroRoomId = this.jinroPlayer.jinroRoomId;
        if (jinroRoomId) {
          this.jinroRoomDetacher = this.refJinroRoom(jinroRoomId).onSnapshot(
            async (snapshot) => {
              const jinroRoom = snapshot.data() as JinroRoomDocument;
              jinroRoom.id = snapshot.id;
              this.$store.commit("setJinroRoom", jinroRoom);
            }
          );
        }
      }
    );
  }

  destroyed() {
    this.jinroPlayerDetacher && this.jinroPlayerDetacher();
    this.jinroRoomDetacher && this.jinroRoomDetacher();
  }

  get refJinroPlayer(): firebase.firestore.DocumentReference {
    return db
      .collection(collectionName.jinroplayers)
      .doc(this.$route.params.jinroPlayerId);
  }

  refJinroGame(jinroGameId: string): firebase.firestore.DocumentReference {
    return db.collection(collectionName.jinrogames).doc(jinroGameId);
  }
  refJinroRoom(jinroRoomId: string): firebase.firestore.DocumentReference {
    return db.collection(collectionName.jinrorooms).doc(jinroRoomId);
  }
}
